import HomeScreenV2 from './HomeScreenV2';
export default HomeScreenV2;
